"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Placeholder = exports.PlaceholderSmall = exports.PlaceholderSimple = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  container: {
    position: 'relative'
  },
  circleContainer: {
    marginRight: 31
  },
  circleContainerSmall: {
    marginRight: 11
  },
  barSimple: {
    position: 'absolute',
    top: '50%',
    left: -31,
    width: 31,
    height: 3,
    backgroundColor: '#f2f2f2'
  },
  barSmall: {
    position: 'absolute',
    top: '50%',
    left: -11,
    width: 11,
    height: 3,
    backgroundColor: '#f2f2f2'
  }
};

var Simple = function Simple(_ref) {
  var classes = _ref.classes,
      first = _ref.first,
      quantity = _ref.quantity;

  var Bar = function Bar() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.barSimple
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.circleContainer
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 19.05 19.05",
    height: 72,
    width: 72
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0 -277.95)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 9.525,
    cy: 287.475,
    r: 9.525,
    fill: "#f2f2f2",
    strokeWidth: 0.193
  })))), quantity === 0 ? !first ? /*#__PURE__*/_react["default"].createElement(Bar, null) : null : /*#__PURE__*/_react["default"].createElement(Bar, null));
};

var PlaceholderSimple = (0, _withStyles["default"])(styles)(Simple);
exports.PlaceholderSimple = PlaceholderSimple;

var Small = function Small(_ref2) {
  var classes = _ref2.classes,
      first = _ref2.first,
      quantity = _ref2.quantity;

  var Bar = function Bar() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.barSmall
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.circleContainerSmall
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 4.233,
    cy: 292.767,
    r: 4.035,
    fill: "#f2f2f2",
    stroke: "#f2f2f2",
    strokeWidth: 0.397,
    transform: "translate(0 -288.533)"
  }))), quantity === 0 ? !first ? /*#__PURE__*/_react["default"].createElement(Bar, null) : null : /*#__PURE__*/_react["default"].createElement(Bar, null));
};

var PlaceholderSmall = (0, _withStyles["default"])(styles)(Small);
exports.PlaceholderSmall = PlaceholderSmall;

var Placeholder = function Placeholder(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: 225,
    height: 187,
    viewBox: "0 0 59.531 49.477"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(.99959 0 0 .99838 -100.96 -38.57)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M101.002 69.656h55.492l4.064 4.158-4.064 4.205h-55.492l3.85-4.205z",
    fill: "#f2f2f2",
    strokeWidth: 0.24
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 130.726,
    cy: 73.838,
    r: 1.522,
    fill: "#fff",
    strokeWidth: 0.15
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 130.78,
    cy: 48.202,
    r: 9.57,
    fill: "#f2f2f2",
    strokeWidth: 0.194
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: 0.794,
    height: 14.363,
    x: 130.383,
    y: 56.309,
    ry: 0,
    fill: "#f2f2f2",
    strokeWidth: 0.108
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(.661 -148.34)",
    fill: "#f2f2f2"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    ry: 0,
    y: 228.581,
    x: 115.485,
    height: 4.009,
    width: 29.266,
    strokeWidth: 0.244
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: 24.722,
    height: 1.871,
    x: 117.757,
    y: 234.658,
    ry: 0,
    strokeWidth: 0.153
  }))));
};

exports.Placeholder = Placeholder;